import { FC, useEffect, useState } from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';
import { Radio, RadioChangeEvent, Row, Space, Typography } from 'antd';
import ReportSection from '../Section';
import { useCurrentMarketRates } from '../../../../../hooks/reports';
import MarketRatesChart from '../../../../Common/MarketRatesChart';
import { MARKETS_DESCRIPTIONS, MARKETS_TITLES } from '../../../../../constants/markets';

type Props = {
  provided?: DraggableProvided;
}

const Markets: FC<Props> = ({provided}) => {
  const name = 'markets';
  const currentMarketRates = useCurrentMarketRates();
  const currentTreasury = useCurrentMarketRates();
  const [years, setYears] = useState<number>(10);

  let interval: ReturnType<typeof setTimeout>;

  const getChartsData = () => {
    currentMarketRates.fetch({ years: 30 });

    currentTreasury.fetch({ years: 10 });
  };

  useEffect(() => {
    getChartsData();
    interval = setInterval(() => {
      getChartsData();
    }, 30000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleChangeTab = (event: RadioChangeEvent) => {
    setYears(event.target.value);
  }

  return (
    <ReportSection
      id={name}
      name={name}
      title="Markets"
      provided={provided}
    >
      <Space style={{ padding: '10px' }} direction="vertical" size={20}>
        <Row>
          <Radio.Group
            defaultValue={years}
            size="large"
            onChange={handleChangeTab}
            style={{ marginBottom: 24 }}
          >
            <Radio.Button value={10}>10-Year Treasury</Radio.Button>
            <Radio.Button value={30}>30-Year MBS</Radio.Button>
          </Radio.Group>

          {years === 10 ? (
                <MarketRatesChart
                  title={MARKETS_TITLES[years]}
                  description={MARKETS_DESCRIPTIONS[years]}
                  data={currentTreasury.data?.data}
                  loading={currentTreasury.loading}
                  reversed
                  height={400}
                  fullWidth
                />
          ) : (
              <MarketRatesChart
                title={MARKETS_TITLES[years as 30]}
                description={MARKETS_DESCRIPTIONS[years as 30]}
                data={currentMarketRates.data?.data}
                loading={currentMarketRates.loading}
                height={400}
                reversed={false}
                fullWidth
              />
          )}

        </Row>
      </Space>
    </ReportSection>
  )
}

export default Markets;
